import { erasmusLogos } from "../config/logos";

export const erasmusLogosService = {
  getLogos({ colorScheme }) {
    return erasmusLogos.map((logo) => ({
      ...logo,
      src:
        logo.src?.[colorScheme] ??
        logo.src?.light ??
        logo.src,
    }));
  },
};